import * as React from "react";
import {ValuableItem} from "@falcon/services";
import {ConfirmModal} from "@falcon/plugin-falcon-journey";
import {RouteComponentProps} from "react-router";
import ValuableItemModal from "../valuablesPage/ValuableItemModal";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {calculateValuablesTotalValue, getAmountWithDecimalDigits} from "../../../../../CommonFunctions";

interface IProps extends RouteComponentProps {
    item: ValuableItem,
    interaction: any,
    cancelled: boolean
}

interface IState {
    showItemModal: boolean
    showRemoveConfirmation: boolean
    item: ValuableItem
}

export default class SpecifiedItemInfo extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            showItemModal: false,
            showRemoveConfirmation: false,
            item: this.props.item
        };
    }

    public render() {
        const valuableItems: ValuableItem[] = this.props.interaction.valuableItems;
        return (
            <>
                {this.renderItemPanel()}
                {this.state.showItemModal &&
                <ValuableItemModal {...this.props}
                                   show={this.state.showItemModal}
                                   hide={() => this.setState({showItemModal: false})}
                                   onConfirm={this.editItem}
                                   item={this.state.item}
                                   itemWordings={PluginTemplates.getSpecifiedItemWordings(this.state.item)}
                                   interactionId={this.props.interaction._id}
                                   totalValueOfItems={calculateValuablesTotalValue(valuableItems)}
                                   insuredValue={this.props.interaction.factors.insuredValue}/>}

                {this.state.showRemoveConfirmation &&
                <ConfirmModal show={this.state.showRemoveConfirmation}
                              onHide={() => this.setState({showRemoveConfirmation: false})}
                              onConfirm={() => this.removeItem(this.state.item!)}
                              confirmButtonText="Yes, please">
                    <div className="fs-20 font-weight-medium font-family-display">
                        Are you sure you want to remove this item from your cover?
                    </div>
                </ConfirmModal>}
            </>
        );
    }

    private renderItemPanel = (): JSX.Element => {
        return (
            <>
                <div>{this.state.item.description}</div>
                <div><b>Cover inside and outside the home</b> for <b>£{this.state.item.value}</b></div>
                <div>Monthly price: <b>{getAmountWithDecimalDigits(this.state.item.premium)}</b></div>
                <div className="d-flex justify-content-between justify-content-md-start mt-2 font-weight-medium text-blue-1 text-decoration-underline">
                    {!this.props.cancelled && <span onClick={() => this.setState({showItemModal: true})} className="mr-5 cursor-pointer">
                        Edit
                    </span>}
                    {!this.props.cancelled && <span onClick={() => this.setState({showRemoveConfirmation: true})} className="cursor-pointer">
                        Remove
                    </span>}
                </div>
            </>
        )
    };

    private removeItem = (item: ValuableItem): void => {
        window.sessionStorage.removeItem("itemToProcess");
        window.sessionStorage.setItem("itemToProcess", JSON.stringify(item));
        this.props.history.push(`/journey/show/product/RentersInsurance/process/mtaRemoveItem/preset/${this.props.interaction._id}`);
    };

    private editItem = (item: ValuableItem): void => {
        this.setState({showItemModal: false, item});
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/yourRentersCoverPage/SpecifiedItemInfo.tsx